import styled from 'styled-components'
import theme from '@app/ui/theme'

export const NavButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 40px;
  padding: 0 10px;
  border-radius: 5px;
  border: 1px solid
    ${({ disabled }) => (disabled ? theme.colors.disabled : theme.colors.secondary)};
  background-color: ${({ disabled }) =>
    disabled ? theme.colors.disabled : theme.colors.light};
  color: ${({ disabled }) =>
    disabled ? theme.colors.dark1 : theme.colors.dark};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  box-shadow: 0 0px 4px 0 ${theme.colors.dark1};

  &:active:not(:disabled) {
    opacity: 0.7;
  }
`

export const NavLabel = styled.span<{ disabled?: boolean }>`
  font-size: 12px;
  font-weight: 600;
  color: ${({ disabled }) => (disabled ? theme.colors.dark1 : 'inherit')};
  min-width: 20px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`
